











import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
import MainTemplate from '@/components/MainTemplate.vue'
import Condition from './components/Condition.vue'
import PaperList from './PaperList.vue'
import DownloadModal from './components/DownloadModal.vue'
import { paperList, platformLogin } from './models/api'

@Component({
  components: {
    MainTemplate,
    Condition,
    PaperList,
    DownloadModal
  }
})
export default class Home extends Vue {
  public visibleDownload = false
  /**
   * init
   */
  public init() {
    console.log('初始化页面')
  }
  public mounted() {
    this.init()
  }
  public home() {
    return document.getElementById('home')
  }
  public async goPlatForm() {
    const data = await platformLogin({ withCredentials: true })
    // console.log(data)
  }
  public created() {
    // this.goPlatForm()
  }
}
